import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'

import {http} from 'hiya-common/src/utils/axios'

// 年度判断主页 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100420621
export const annual_inventory = createAsyncThunk(
  'annual_inventory',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'p0'
          | 'p1'
          | 'p2'
          | 'p3'
          | 'p4'
          | 'p5'
          | 'p6'
          | 'p7'
          | 'p8'
          | 'invite_url'
        >
      >
    >('/live/misc/annual_inventory', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 年度盘点im消息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100420733
export const send_annual_im = createAsyncThunk(
  'send_annual_im',
  // 0:发送给送礼人，1收礼人
  async (arg: {type: 0 | 1; mid: number}, store: any) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/live/misc/send_annual_im',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
// 领取年度盘点奖励 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100420730
export const rec_annual_reward = createAsyncThunk(
  'rec_annual_reward',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/live/misc/rec_annual_reward',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
// 年度盘点公益捐款 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122811303
export const annual_inventory_donation = createAsyncThunk(
  'annual_inventory_donation',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/live/misc/annual_inventory_donation',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
// doc2.ixiaochuan.cn/pages/viewpage.action?pageId=11891314
export const uploadImg = createAsyncThunk(
  'rec_uploadImg',
  async (arg: {image_contents: any}, store: any) => {
    const resp = await http.post<HiyaRes<{image_urls: string[]}>>(
      '/live/misc/upload_img',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
interface InitialStateType {
  isLoading?: boolean
  qr?: string
  config?: any
  p0?: {
    name: string
  }
  p1?: {
    name: string
    year: number
    month: number
    day: number
    duration: number
  }
  p2?: {
    // 和运营文档上的类型对应起来
    type: number
    year: number
    month: number
    day: number
    duration: number
    percent: number
    special_year: number
    special_month: number
    special_day: number
    special_duration: number
  }
  p3?: {
    rec_coins: number
    rec_percent: number
    rec_user: {mid: number; name: string; avatar: string}[]
    send_coins: number
    send_percent: number
    send_user: {mid: number; name: string; avatar: string}[]
  }
  p4?: {
    type: number
    name: string
    duration: number
    year: number
    month: number
    day: number
  }
  p5?: {
    feed_cnt: number
    comment_cnt: number
    like_cnt: number
    percent: number
  }
  p6?: {
    year: number
    mic_duration: number
    rec_name: string
    send_name: string
    cp_name: string
    feed_cnt: number
    type: 1 | 2 | 3 // 1人设，2关键词，3祝福
    key_words: string
  }
  p7?: {
    type: 1 | 2 | 3 // 1人设，2关键词，3祝福
    key_words: string
    desc: string
    gift_status: number // 0未领取，1已领取
  }
  p8?: {
    name: string
    avatar: string
    duration: number
    percent: number
    feed_cnt: number
    key_words: string
  }
  invite_url?: string
}

const initialState: InitialStateType = {
  isLoading: true,
}

export const AnnualSum2022Slice = createSlice({
  name: 'AnnualSum2022',
  initialState,
  reducers: {
    changeQr: (state, action: PayloadAction<string>) => {
      Object.assign(state, {
        qr: action.payload,
      })
    },
    changeLoading: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        isLoading: action.payload,
      })
    },
    // getWebMessage: (
    //   state,
    //   action: PayloadAction<{
    //     status_expire: number
    //     round_status: number
    //   }>
    // ) => {
    //   Object.assign(state, action.payload)
    // },
  },
  extraReducers: (builder) => {
    // 主页
    builder.addCase(annual_inventory.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default AnnualSum2022Slice.reducer
export const AnnualSum2022Actions = AnnualSum2022Slice.actions
